export enum EAplicacaoRegraPreco {
    AcrescimoValor = 1,
    AcrescimoPercentual = 2,
    DescontoValor = 3,
    DescontoPercentual = 4,
}
